import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveDateSettingsFailed, saveDateSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import loadDateSettings from './loadDateSettings';
import loadStatus from '../../System/sagas/loadStatus';

export default function* saveDateSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/time-settings`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(saveDateSettingsSuccessful(data));
      yield call(loadDateSettings, {});
      yield call(loadStatus, {});
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(saveDateSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(saveDateSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
